import { WORKFLOW_MESSAGE_TYPE_SMS } from 'Api/beAutomationApi'
import { notifyParent } from 'mailup-react-helpers'
import {
  ACTION_BUTTON_TYPE_DELETE,
  ACTION_BUTTON_TYPE_EDIT,
  ButtonAction,
  LINK_VARIANT_HIGHLIGHT,
  Text,
  TEXT_VARIANT_SMALL_LIGHT,
  TooltipUtils,
  TruncateAndTooltip
} from 'mailup-web-components'
import { workflowSmsMessageSubjectSelector } from 'Pages/Workflow/recoil/state/data'
import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

import * as S from './WorkflowBuilder.styles'

const SmsItem = ({
  draggableId,
  idMessage,
  onDelete,
  onEdit,
  subject,
  currentDragItem
}) => {
  const intl = useIntl()

  useEffect(() => {
    TooltipUtils.rebuild()
  }, [])

  // const subject = useRecoilValue(workflowSmsMessageSubjectSelector(idMessage))

  const handleSubjectClick = () => {
    notifyParent('openSMSPreview', [idMessage])
  }

  const handleDelete = () => {
    onDelete(draggableId)
  }

  const handleEdit = () => {
    onEdit(draggableId, WORKFLOW_MESSAGE_TYPE_SMS)
  }

  const smsMessageSubject = useRecoilValue(
    workflowSmsMessageSubjectSelector(idMessage)
  )

  return (
    <S.InnerItem>
      {currentDragItem !== draggableId && <S.ItemHorizontalLine />}
      <S.ItemCircle>
        {currentDragItem !== draggableId && <S.Circle />}
      </S.ItemCircle>
      <S.WorkflowBuilderItem>
        <S.ItemLeft>
          {intl.formatMessage({
            id: 'Load.AutomationWorkflow.DragElementMessageSms'
          })}
        </S.ItemLeft>
        <S.ItemRight>
          {idMessage > 0 ? (
            <>
              <S.LinkBold
                variant={LINK_VARIANT_HIGHLIGHT}
                firstOf2Line
                onClick={handleSubjectClick}
              >
                <TruncateAndTooltip text={subject || smsMessageSubject} />
              </S.LinkBold>
              <Text variant={TEXT_VARIANT_SMALL_LIGHT}>
                {intl.formatMessage({ id: 'Load.MailupCommon.Id' })} {idMessage}
              </Text>
            </>
          ) : (
            <S.LinkBold
              variant={LINK_VARIANT_HIGHLIGHT}
              verticalCenter
              onClick={handleEdit}
            >
              {intl.formatMessage({
                id: 'Load.AutomationWorkflow.DragElementChoseMessageSms'
              })}
            </S.LinkBold>
          )}
        </S.ItemRight>
        <S.ItemActions withGhostActions>
          <div className='ghost'>
            {idMessage > 0 && (
              <ButtonAction
                type={ACTION_BUTTON_TYPE_EDIT}
                onClick={handleEdit}
              />
            )}
            <ButtonAction
              type={ACTION_BUTTON_TYPE_DELETE}
              onClick={handleDelete}
            />
          </div>
        </S.ItemActions>
      </S.WorkflowBuilderItem>
    </S.InnerItem>
  )
}

SmsItem.propTypes = {
  idMessage: PropTypes.number,
  draggableId: PropTypes.string,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  subject: PropTypes.string,
  currentDragItem: PropTypes.string
}

export default SmsItem
